export enum FormFieldEnum {
  Radio = 1,
  Dropdown,
}
